__turbopack_context__.v({
  "body": "AuthorHeader-module-scss-module__r5u9DW__body",
  "description": "AuthorHeader-module-scss-module__r5u9DW__description",
  "informationHeader": "AuthorHeader-module-scss-module__r5u9DW__informationHeader",
  "informationSection": "AuthorHeader-module-scss-module__r5u9DW__informationSection",
  "profilePicture": "AuthorHeader-module-scss-module__r5u9DW__profilePicture",
  "profilePictureSection": "AuthorHeader-module-scss-module__r5u9DW__profilePictureSection",
  "wrapper": "AuthorHeader-module-scss-module__r5u9DW__wrapper",
});
